import type * as mapboxgl from 'mapbox-gl';

export class MapElementControl implements mapboxgl.IControl {
  constructor(private readonly element: HTMLElement) {}

  onAdd(): HTMLElement {
    return this.element;
  }

  onRemove(): void {
    this.element.remove();
  }
}
